import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetOrderById } from './order';

export type GetOrderOptions = {
    fetchOnce?: boolean;
    includeGroups?: boolean;
    includeProducts?: boolean;
    includeQuotes?: boolean;
};

export function getUseOrderQueryKey(orderId: string, options?: GetOrderOptions) {
    return ['order', orderId, options];
}

export const useOrder = (orderId: string, options?: GetOrderOptions) => {
    const { getOrderById } = useGetOrderById();
    const { fetchOnce = false } = options ?? {};

    return useSuspenseQuery({
        queryKey: getUseOrderQueryKey(orderId, options),
        queryFn: async () => getOrderById(orderId, options),
        ...(fetchOnce && { staleTime: Infinity, cacheTime: Infinity }),
        refetchOnWindowFocus: false,
    });
};

export const useFullOrder = (orderId: string) => {
    const { getOrderById } = useGetOrderById();

    return useSuspenseQuery({
        queryKey: ['full-order', orderId],
        queryFn: async () =>
            getOrderById(orderId, {
                includeGroups: true,
                includeProducts: true,
            }),
        refetchOnWindowFocus: false,
    });
};
